export default __webpack_public_path__ + "static/automobile-flow-5c107cf85ed66a137c8f14053c810186.gif";